/**
 * Group Cell Renderers
 *
 * These components wrap the name renderers with group cell functionality
 * (expand/collapse buttons, indentation, etc.) using the withGroupCell HOC
 */

import { withGroupCell } from './withGroupCell'
import { HeadingNameCellRenderer } from './nameCellRenderers/HeadingNameCellRenderer'
import { AccountNameCellRenderer } from './nameCellRenderers/AccountNameCellRenderer'
import { DimensionNameCellRenderer } from './nameCellRenderers/DimensionNameCellRenderer'
import { DimensionGroupNameCellRenderer } from './nameCellRenderers/DimensionGroupNameCellRenderer'
import { InvestmentMenuCellRenderer } from './nameCellRenderers/InvestmentMenuCellRenderer'
import { AmendmentMenuCellRenderer } from './nameCellRenderers/AmendmentMenuCellRenderer'
import { RowActionsNameCellRenderer } from './nameCellRenderers/RowActionsNameCellRenderer'

// Create wrapped group cell components
export const HeadingGroupCell = withGroupCell(HeadingNameCellRenderer)
export const AccountGroupCell = withGroupCell(AccountNameCellRenderer)
export const DimensionGroupCell = withGroupCell(DimensionNameCellRenderer)
export const DimensionGroupGroupCell = withGroupCell(DimensionGroupNameCellRenderer)
export const InvestmentMenuGroupCell = withGroupCell(InvestmentMenuCellRenderer)
export const AmendmentMenuGroupCell = withGroupCell(AmendmentMenuCellRenderer)
export const RowActionsGroupCell = withGroupCell(RowActionsNameCellRenderer)
// export const DriverGroupCell = withGroupCell(DriverNameCellRenderer)
